export namespace ComplianceStatusConstants {
  export const APPROVED: string = 'APPROVE';
  export const PENDING_REVIEW: string = 'PENDING';
  export const ACTION_REQUIRED: string = 'ACTION';
}
